import { useTheme } from "@emotion/react";
import { GaugeComponent } from "react-gauge-component";
export default function GaugeGraphComponent(params) {
	const theme = useTheme();
	const { value } = params;
	const isDark = theme.palette.mode === "dark"; //Modo dark
	//Cor do texto
	const labelColor = isDark
		? theme.palette.white.main
		: theme.palette.black.main; //Cor do texto

	//Estilo do tooltip
	const tooltipBaseStyle = {
		backgroundColor: theme.palette.paletteCharts.lineCharts,
		color: labelColor,
		fontSize: "13px",
		fontWeight: "bold",
		textShadow: "none",
		border: "none",
	};
	//Gerar texto com quadro ao lado (PARECIDO COM O RECHARTS)
	const generateTooltipText = (color, label) => `
  <div style="display: flex; align-items: center; gap: 6px;">
    <div style="width: 10px; height: 10px; background-color: ${color}; border-radius: 2px;"></div>
    ${label}
  </div>
`;
	//Objeto do arco
	const createSubArc = (limit, color, label) => ({
		limit,
		tooltip: {
			text: generateTooltipText(color, label),
			style: tooltipBaseStyle,
		},
	});
	//Criação de 3 arcos do grafico com o tamanho, cor e texto
	const subArcs = [
		createSubArc(60, theme.palette.colors.green.medium, "Uso baixo"),
		createSubArc(80, theme.palette.colors.orange.medium, "Uso médio"),
		createSubArc(100, theme.palette.colors.pink.dark, "Uso alto"),
	];

	return (
		<>
			<GaugeComponent
				value={value || 0}
				type="radial"
				labels={{
					tickLabels: {
						type: "inner",
						ticks: [20, 40, 60, 80, 100].map((value) => ({
							value,
						})),
						defaultTickLineConfig: { color: labelColor },
						defaultTickValueConfig: { style: { fill: labelColor } },
					},
					valueLabel: {
						matchColorWithArc: true,
						style: { textShadow: "none", fontWeight: "bold" },
					},
				}}
				arc={{
					cornerRadius: 3,
					colorArray: [
						theme.palette.colors.green.medium,
						theme.palette.colors.orange.medium,
						theme.palette.colors.pink.dark,
					],
					subArcs,
					padding: 0.01,
					width: 0.2,
				}}
				pointer={{
					elastic: true,
					animationDelay: 0,
					length: 0.5,
					width: 13,
					color: labelColor,
				}}
			/>
		</>
	);
}
